import React from 'react';
import { Link } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';
import { constantStyles } from '../constants/constantStyles';
import { useIsAdmin } from '../auth/useAdmin';
import LogoutButton from '../auth/LogoutButton';

const Navbar = () => {
    const { isAuthenticated, isLoading, user } = useAuth0();
    const isAdmin = useIsAdmin();
    return (
        <>
            <nav style={styles.navHolder}>
                <ul style={styles.navList}>
                    <li style={styles.li}><Link style={styles.link} to="/featured">Featured</Link></li>
                    {/* <li style={styles.li}><Link style={styles.link} to="/new">New</Link></li> */}
                    <li style={styles.li}><Link style={styles.link} to="/women">Women</Link></li>
                    <li style={styles.li}><Link style={styles.link} to="/men">Men</Link></li>
                    {/* <li style={styles.li}><Link style={styles.link} to="/insights">Insights</Link></li>
                    <li style={styles.li}><Link style={styles.link} to="/brands">Brands</Link></li> */}
                    <li style={styles.li}><Link style={styles.link} to="/likes">Likes</Link></li>
                    <li style={styles.li}><Link style={{...styles.link, ...styles.saleLink}} to="/sale">Sale</Link></li>

                    {/* Admin links - only show if user is admin */}
                    {isAdmin && (
                        <>
                            <li style={styles.li}>
                                <Link style={{...styles.link, ...styles.adminLink}} to="/admin/dashboard">Dashboard</Link>
                            </li>
                            <li style={styles.li}>
                                <Link style={{...styles.link, ...styles.adminLink}} to="/admin/stale">Stale</Link>
                            </li>
                        </>
                    )}

                    {/* Auth button - only show logout when authenticated */}
                    {!isLoading && isAuthenticated && (
                        <li style={styles.li}>
                            <LogoutButton style={{...styles.link, ...styles.authButton}} />
                        </li>
                    )}
                </ul>

                {/* Admin indicator badge */}
                {isAdmin && (
                    <div style={styles.adminBadge}>
                        Admin Mode
                    </div>
                )}
            </nav>
        </>
    );
};

export default Navbar;
const styles = {
    navHolder: {
        borderTop: '1px',
        borderBottom: '1px',
        borderLeft: '0px',
        borderRight: '0px',
        borderColor: constantStyles.mainDarkGreen,
        borderStyle: 'solid',
    },
    navList: {
        display: 'flex',
        justifyContent: 'space-between',
        listStyle: 'none',
        margin: constantStyles.outermostMargin,
        padding: '16px 16px',
    },
    li: {
    },
    link: {
        textDecoration: 'none',
        fontSize: '18px',
        fontFamily: constantStyles.mainFontFamily,
        color: constantStyles.mainDarkGreen,
    },
    saleLink: {
        color: 'rgb(216, 54, 4)',
    },
    adminLink: {
        color: '#9333ea',
        fontWeight: '500',
    },
    authButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        fontWeight: '500',
    },
    adminBadge: {
        backgroundColor: '#9333ea',
        color: 'white',
        padding: '4px 12px',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '4px',
        textAlign: 'center',
        margin: '8px 16px',
    }
};